import type { IxcFundingV1SourceKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const FUNDING_SOURCE_BASE_PATH = getResolvedPath('/funding/source');

export const getFundingSourcePath: EntityPathBuilder<IxcFundingV1SourceKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return getResolvedPath(FUNDING_SOURCE_BASE_PATH);
    case 'detail': {
      if (!context?.keys?.sourceId) {
        return undefined;
      }

      if (context?.keys?.accountId) {
        return getResolvedPath('/registration/account/$accountId/funding/source/$sourceId', context.keys);
      }

      return getResolvedPath(`${FUNDING_SOURCE_BASE_PATH}/$sourceId`, context.keys);
    }
  }
};

export function getFundingSourceDetailPath(sourceId: string | undefined, accountId?: string) {
  if (!sourceId) {
    return undefined;
  }

  return getFundingSourcePath({ kind: 'detail', keys: { sourceId, accountId } });
}
